import Phaser from 'phaser';

/** 튜토리얼 이후 — 지옥 제1층 진입 연출 후 허브(대기실)로 보냅니다. */
export class Hell1EntryScene extends Phaser.Scene {
  private proceeded = false;

  constructor() {
    super({ key: 'Hell1EntryScene' });
  }

  create(): void {
    const { width, height } = this.scale;
    this.cameras.main.setBackgroundColor('#0f0a14');

    this.registry.set('progress.reachedHell1Entry', true);

    this.add
      .text(width / 2, height * 0.36, '지옥 제1층', {
        fontFamily: 'system-ui, "Segoe UI", sans-serif',
        fontSize: '38px',
        color: '#efe8f4',
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height * 0.48, '단테가 묘사한 나선의 첫 무릎,\n이제부터는 거점에서 장비와 각인을 다루게 된다.', {
        fontFamily: 'system-ui, "Segoe UI", sans-serif',
        fontSize: '15px',
        color: '#b8b4c8',
        align: 'center',
        lineSpacing: 6,
        wordWrap: { width: width - 72 },
      })
      .setOrigin(0.5);

    const hint = this.add
      .text(width / 2, height * 0.72, '터치하거나 스페이스 — 거점(대기실)으로', {
        fontFamily: 'system-ui, "Segoe UI", sans-serif',
        fontSize: '14px',
        color: '#8a87a0',
      })
      .setOrigin(0.5);

    this.tweens.add({
      targets: hint,
      alpha: { from: 0.45, to: 1 },
      duration: 950,
      yoyo: true,
      repeat: -1,
    });

    const goHub = () => {
      if (this.proceeded) return;
      this.proceeded = true;
      this.scene.start('HubScene');
    };

    this.input.once('pointerdown', goHub);
    this.input.keyboard?.once('keydown-SPACE', goHub);

    this.time.delayedCall(5200, goHub);
  }
}
